import {
  IconWrapper,
  ImageWrapper,
  IStyles,
  theme,
} from '@geneo2-web/shared-ui';
import { Box, Popover, Typography, useMediaQuery } from '@mui/material';
import { pxTovW } from 'libs/shared-ui/src/commonUtils/resizeUtils';
import { pxToRem } from 'libs/shared-ui/src/commonUtils/resizeUtils';
import { MouseEvent, useState } from 'react';

const styles: IStyles = {
  root: {
    border: '1px solid #F54040',
    borderRadius: { xs: pxToRem(16), md: pxTovW(16) },
    paddingX: { xs: pxToRem(14), md: pxTovW(14) },
    paddingY: { xs: pxToRem(10), md: pxTovW(10) },
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(20) },
    width: { xs: '90%', md: 'max-content' },
    margin: { xs: 'auto', md: 'auto' },
    marginTop: { xs: pxToRem(10), md: pxTovW(20) },
    backgroundColor: '#FFDEDE',
  },
  imageWrapper: {
    width: { xs: pxToRem(50), md: pxTovW(65) },
    height: { xs: pxToRem(50), md: pxTovW(65) },
  },
  textBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
  },
  textWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
  },
};

export const ProctoringInfoDisplay = () => {
  return (
    <Box sx={styles.root}>
      <ImageWrapper
        name="data-analysis-monitor"
        type="png"
        parentFolder="icons"
        styles={styles.imageWrapper}
      />

      <Box sx={styles.textBox}>
        <Box sx={styles.textWrapper}>
          <Typography variant="h3" fontWeight="bold">
            This assessment is being actively proctored
          </Typography>

          <ProctoringInfoNode />
        </Box>

        <Typography variant="h4">
          Your assessment session is under supervision. Continue to maintain
          exam integrity.
        </Typography>
      </Box>
    </Box>
  );
};

// -------------------------------------------------------------

const ProctoringInfoNode = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  const proctoringInfo = [
    'Use Fullscreen Mode',
    'Avoid Switching Tabs',
    'Don’t Try Multiple Sessions',
    'Don’t Keep Device Idle for Too Long',
  ];

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box onClick={handleClick}>
      <IconWrapper
        name="tooltip-black"
        parentFolder="icons"
        type="png"
        size="small"
        customSx={{
          height: { xs: pxToRem(14), md: pxTovW(20), lg: pxTovW(14) },
          width: { xs: pxToRem(14), md: pxTovW(20), lg: pxTovW(14) },
          cursor: 'pointer',
        }}
      />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: isMobile ? 'bottom' : 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: isMobile ? 'top' : 'bottom',
          horizontal: 'center',
        }}
        disableRestoreFocus
        slotProps={{
          paper: {
            sx: {
              zIndex: 1000,
              backgroundColor: 'transparent',
              boxShadow: 'none',
            },
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: '#050505',
            color: '#FFFFFF',
            padding: { xs: pxToRem(10), md: pxTovW(10) },
            minWidth: { xs: pxToRem(240), md: pxTovW(240) },
            borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
            marginLeft: { xs: pxToRem(20), md: pxTovW(0) },
            marginBottom: { xs: pxToRem(35), md: pxTovW(20) },
            position: 'relative',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              border: '1px solid #FFFFFF',
              borderRadius: { xs: pxToRem(16), md: pxTovW(16) },
            }}
          >
            <Typography
              textAlign="center"
              sx={{
                fontWeight: 600,
                fontSize: { xs: pxToRem(16), md: pxTovW(18) },
                padding: { xs: pxToRem(10), md: pxTovW(10) },
              }}
            >
              Proctoring Do’s & Don’ts
            </Typography>

            {proctoringInfo.map((info, index) => (
              <Typography
                key={info}
                sx={{
                  fontSize: { xs: pxToRem(14), md: pxTovW(16) },
                  fontWeight: 600,
                  borderTop: '1px solid #FFFFFF',
                  padding: { xs: pxToRem(10), md: pxTovW(10) },
                }}
              >
                {index + 1}. {info}
              </Typography>
            ))}
          </Box>
        </Box>

        {/* <Box
          sx={{
            width: 0,
            height: 0,
            borderLeft: {
              xs: pxToRem(15) + ' solid transparent',
              md: pxTovW(15) + ' solid transparent',
            },
            borderRight: {
              xs: pxToRem(15) + ' solid transparent',
              md: pxTovW(15) + ' solid transparent',
            },
            borderTop: {
              xs: pxToRem(15 * Math.sqrt(3)) + ' solid #050505',
              md: pxTovW(15 * Math.sqrt(3)) + ' solid #050505',
            }, // x * √3, for equilateral proportions
            position: 'absolute',
            left: { xs: '35%', md: '45%' },
            bottom: { xs: pxToRem(10), md: pxTovW(0) },
            margin: 'auto',
            zIndex: 2,
          }}
        ></Box> */}
      </Popover>
    </Box>
  );
};

// -------------------------------------------------------------
